// Моковые данные для демонстрации
export const folders = [
    { id: 'inbox',   name: 'Входящие',    icon: '📥', count: 12 },
    { id: 'starred', name: 'Помеченные',  icon: '⭐', count: 3  },
    { id: 'sent',    name: 'Отправленные', icon: '📤', count: 0  },
    { id: 'drafts',  name: 'Черновики',    icon: '📝', count: 2  },
    { id: 'spam',    name: 'Спам',         icon: '🚫', count: 5  },
    { id: 'trash',   name: 'Корзина',      icon: '🗑️', count: 0  },
];

export const labels = [
    { id: 'work',     name: 'Работа',     color: '#4361ee' },
    { id: 'important', name: 'Важное',    color: '#f72585' },
    { id: 'personal', name: 'Личное',     color: '#7209b7' },
    { id: 'iot',      name: 'IoT',        color: '#4cc9f0' },
];

export const mails = [
    {
        id: 1,
        folder: 'inbox',
        from: { name: 'Система мониторинга', email: 'alerts@mas-iot.ru', avatar: 'С' },
        to: 'admin@mas-iot.ru',
        subject: '⚠️ Превышен порог температуры датчика #A-102',
        preview: 'Датчик температуры #A-102 зафиксировал значение 87°C, что превышает установленный порог 75°C...',
        body: `Уважаемый администратор,

Датчик температуры #A-102 (зона: производственный цех №3) зафиксировал критическое значение: 87°C.
Установленный порог: 75°C.
Превышение: +12°C.

Рекомендуем немедленно проверить состояние оборудования и системы охлаждения.

— Автоматическая система мониторинга MAS-IOT`,
        date: '2026-10-04T09:15:00',
        read: false,
        starred: true,
        labels: ['important', 'iot'],
        attachments: [{ name: 'report_A-102.pdf', size: '245 KB' }],
    },
    {
        id: 2,
        folder: 'inbox',
        from: { name: 'Иван Петров', email: 'i.petrov@mas-iot.ru', avatar: 'ИП' },
        to: 'admin@mas-iot.ru',
        subject: 'Отчёт по ресурсам за сентябрь',
        preview: 'Добрый день! Направляю отчёт по расходу ресурсов за сентябрь 2026...',
        body: `Добрый день!

Направляю отчёт по расходу ресурсов за сентябрь 2026 года.
Основные показатели:
— Электроэнергия: 12 450 кВт·ч (-3% к августу)
— Вода: 340 м³ (+2%)
— Газ: 890 м³ (-1.5%)

Подробности в приложении.

С уважением,
Иван Петров
Отдел ресурсов`,
        date: '2026-10-03T16:42:00',
        read: true,
        starred: false,
        labels: ['work'],
        attachments: [
            { name: 'resources_september.xlsx', size: '1.2 MB' },
            { name: 'charts.pdf', size: '890 KB' },
        ],
    },
    {
        id: 3,
        folder: 'inbox',
        from: { name: 'Отдел закупок', email: 'purchases@mas-iot.ru', avatar: 'ОЗ' },
        to: 'admin@mas-iot.ru',
        subject: 'Согласование заявки №2847',
        preview: 'Требуется ваше согласование по заявке на закупку партии датчиков...',
        body: `Коллеги,

Требуется ваше согласование по заявке №2847 на закупку:
— Датчики температуры: 50 шт.
— Датчики давления: 30 шт.
— Контроллеры: 10 шт.

Общая стоимость: 1 245 000 ₽.
Поставщик: ООО «ТехноСенсор».

Просим рассмотреть в течение 2 рабочих дней.`,
        date: '2026-10-03T11:20:00',
        read: false,
        starred: false,
        labels: ['work', 'important'],
        attachments: [],
    },
    {
        id: 4,
        folder: 'inbox',
        from: { name: 'Служба поддержки', email: 'support@mas-iot.ru', avatar: 'СП' },
        to: 'admin@mas-iot.ru',
        subject: 'Плановое обновление системы 10.10.2026',
        preview: 'Уведомляем о плановом обновлении системы MAS-IOT до версии 3.4.2...',
        body: `Уважаемые пользователи!

Уведомляем о плановом обновлении системы MAS-IOT до версии 3.4.2,
которое состоится 10 октября 2026 года с 02:00 до 04:00 (МСК).

В этот период система будет недоступна.

Что нового:
— Улучшена производительность обработки данных
— Добавлены новые типы графиков
— Исправлены ошибки экспорта отчётов
— Обновлён интерфейс уведомлений

Приносим извинения за возможные неудобства.`,
        date: '2026-10-02T14:00:00',
        read: true,
        starred: true,
        labels: ['important'],
        attachments: [],
    },
    {
        id: 5,
        folder: 'inbox',
        from: { name: 'Анна Смирнова', email: 'a.smirnova@mas-iot.ru', avatar: 'АС' },
        to: 'admin@mas-iot.ru',
        subject: 'График дежурств на октябрь',
        preview: 'Коллеги, направляю обновлённый график дежурств на октябрь...',
        body: `Коллеги,

Направляю обновлённый график дежурств на октябрь 2026 года.
Изменения:
— 12.10 — дежурный Петров И.
— 19.10 — дежурный Сидоров А.
— 26.10 — дежурный Смирнова А.

Просьба подтвердить получение.

Анна Смирнова
Отдел кадров`,
        date: '2026-10-01T10:30:00',
        read: true,
        starred: false,
        labels: ['work'],
        attachments: [{ name: 'schedule_october.pdf', size: '156 KB' }],
    },
    {
        id: 6,
        folder: 'sent',
        from: { name: 'Вы', email: 'admin@mas-iot.ru', avatar: 'А' },
        to: 'i.petrov@mas-iot.ru',
        subject: 'Re: Отчёт по ресурсам за сентябрь',
        preview: 'Иван, спасибо за отчёт. Показатели в норме, но обратите внимание...',
        body: `Иван,

Спасибо за отчёт. Показатели в норме, но обратите внимание на рост потребления воды на 2%.
Прошу подготовить детальный анализ по этому направлению.

С уважением,
Администратор`,
        date: '2026-10-03T17:15:00',
        read: true,
        starred: false,
        labels: ['work'],
        attachments: [],
    },
    {
        id: 7,
        folder: 'drafts',
        from: { name: 'Вы', email: 'admin@mas-iot.ru', avatar: 'А' },
        to: '',
        subject: 'Планы на ноябрь',
        preview: 'Черновик: обсудить с командой планы по развитию системы на ноябрь...',
        body: 'Черновик: обсудить с командой планы по развитию системы на ноябрь...',
        date: '2026-10-04T08:00:00',
        read: true,
        starred: false,
        labels: [],
        attachments: [],
    },
];